import formatFileSize from './utils'

const messages = {
  _default: () => `er ikke gyldig.`,
  after: (field, [target]) => `skal være efter ${target}.`,
  alpha_dash: () =>
    `må kun indeholde tal, bogstaver, bindestreger og underscores.`,
  alpha_num: () => `må kun indeholde tal og bogstaver.`,
  alpha_spaces: () => `må kun indeholde bogstaver og mellemrum.`,
  alpha: () => `må kun indeholde bogstaver.`,
  before: (field, [target]) => `skal være før ${target}.`,
  between: (field, [min, max]) => `skal være mellem ${min} og ${max}.`,
  confirmed: (field, [confirmedField]) =>
    `skal matche ${confirmedField}.`,
  date_between: (field, [min, max]) =>
    `skal være mellem ${min} og ${max}.`,
  date_format: (field, [format]) => `skal være i formatet: ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `skal være numerisk og må maksimalt indeholde ${
      decimals === '*' ? '' : decimals
    } decimaler.`,
  digits: (field, [length]) => `skal være et tal på ${length} cifre.`,
  dimensions: (field, [width, height]) =>
    `skal være ${width} pixels gange ${height} pixels.`,
  email: () => `skal være en gyldig email.`,
  ext: () => `skal være en gyldig filtype.`,
  image: () => `skal være et billede.`,
  in: () => `skal være en gyldig værdi.`,
  ip: () => `skal være en gyldig ip-adresse.`,
  max: (field, [length]) => `må maksimalt være ${length} karakterer.`,
  mimes: () => `skal være en gyldig filtype.`,
  min: (field, [length]) => `skal minimum være ${length} karakterer.`,
  not_in: () => `skal være en gyldig værdi.`,
  numeric: () => `skal være numerisk.`,
  regex: () => `skal have et gyldigt format.`,
  required: () => `skal udfyldes.`,
  size: (field, [size]) =>
    `må maksimalt have en størrelse på ${formatFileSize(size)}.`,
  url: () => `skal være en gyldig URL.`,
  fullName: () => 'er ikke gyldig (navn, fornavn og maks. 120 tegn)',
  emailInput: () => 'skal være en gyldig email.',
  fullNamePerCountry: () => 'er ikke gyldig (navn, fornavn og maks. 18 tegn)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'da',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/da.js